import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExhibitionNavBar = ({ onAction }) => {
  const navItems = [
    { id: 'chat', label: 'Chat', icon: 'MessageSquare' },
    { id: 'info-desk', label: 'Info Desk', icon: 'Info' },
    { id: 'explore-booths', label: 'Explore Booths', icon: 'Building2' },
    { id: 'search-courses', label: 'Search Courses', icon: 'Search' },
    { id: 'talk-to-universities', label: 'Talk to Universities', icon: 'Video' },
    { id: 'win-prizes', label: 'Win Prizes', icon: 'Trophy' }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 h-16 bg-gray-400 shadow-lg z-50">
      <div className="max-w-[1600px] mx-auto px-4 h-full flex items-center justify-between">
        <Link to="/student-dashboard" className="flex items-center gap-3 text-white hover:opacity-90 transition-opacity">
          <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
            <Icon name="GraduationCap" size={24} color="white" />
          </div>
          <span className="text-xl font-heading font-bold hidden md:block">Studyexpo</span>
        </Link>

        <div className="flex items-center gap-2 overflow-x-auto">
          {navItems?.map((item) => (
            <button
              key={item?.id}
              onClick={() => onAction?.(item?.id)}
              className="flex items-center gap-2 px-4 py-2 text-white hover:bg-white/20 rounded-lg transition-colors whitespace-nowrap"
            >
              <Icon name={item?.icon} size={20} color="white" />
              <span className="font-medium text-sm hidden lg:inline">{item?.label}</span>
            </button>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            className="text-white hover:bg-white/20"
          >
            <Icon name="Bell" size={20} color="white" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="text-white hover:bg-white/20"
          >
            <Icon name="User" size={20} color="white" />
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default ExhibitionNavBar;